<template>
  <el-card>
    <div class="mar-btm-10 clearfix">
      <div class="pull-right search-area">
        <div class="box-inline" style="width: 200px; vertical-align:middle">
          <el-select v-model="queryForm.online" placeholder="设备在线状态">
            <el-option label="所有设备" value="all"></el-option>
            <el-option label="在线设备" value="1"></el-option>
            <el-option label="离线设备" value="0"></el-option>
          </el-select>
        </div>
        <div class="box-inline" style="width: 200px; vertical-align:middle">
          <el-select v-model="queryForm.group_id" placeholder="选择设备分组">
            <el-option label="所有分组" :value="null"></el-option>
            <el-option v-for="group in groups" :label="group.name" :value="group.id" :key="group.id"></el-option>
          </el-select>
        </div>
        <div class="box-inline" style="width: 200px; vertical-align:middle">
          <el-autocomplete v-model="queryForm.tags" placeholder="搜索设备标签" :fetch-suggestions="querySearchAsync" style="width: 100%;"></el-autocomplete>
        </div>
        <div class="box-inline" style="width: 200px; vertical-align:middle">
          <el-input v-model="queryForm.q" placeholder="搜索设备编号或名称" @keyup.enter.native="onSubmitQuery"></el-input>
        </div>
        <el-button size="small" @click="onSubmitQuery" title="搜索">
          <i class="ion-search"></i>
        </el-button>
      </div>
    </div>

    <div>
      <el-table :data="clientList" @row-click="showClient">
        <el-table-column type="index" width="52"></el-table-column>
        <el-table-column prop="sn" label="设备编号"></el-table-column>
        <el-table-column prop="name" label="设备名称"></el-table-column>
        <el-table-column prop="online_status" label="状态" width="80">
          <template scope="scope">
            <el-tag type="success" v-if="scope.row.online_status">在线</el-tag>
            <el-tag type="default" v-else>离线</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message_amount" label="数据量"></el-table-column>
        <el-table-column prop="group_id" label="所属分组">
          <template scope="scope">
            <span v-if="groups.length > 0">{{findGroup(scope.row.group_id)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tags" label="设备标签">
          <template scope="scope">
            <span v-for="tag in scope.row.tags">
              <el-tag type="primary">{{tag}}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template scope="scope">
            <div class="text-nowrap">
              <!-- <el-button type="danger" size="small" title="删除" @click="onDeleteClient(scope.row.id)" style="width: 33px;">
                <i class="ion-trash-b"></i>
              </el-button> -->
              <el-button size="small" @click="showClient(scope.row)"><i class="ion-forward"></i></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="clearfix mar-top">
        <el-pagination class="pull-right"
          @current-change="changePage"
          layout="total, prev, pager, next"
          :total="totalItem"
          :current-page="currentPage"
          :page-size="15">
        </el-pagination>
      </div>
    </div>
  </el-card>
</template>
<script>
import { mapState } from 'vuex';
import { find as _find } from 'lodash';

export default {
  data() {
    return {
      applicationId: this.$route.params.appId,
      queryForm: { ...this.$store.state.application.messageClientQueryForm },
      clientList: [],
      totalItem: 1,
      isMessage: false,
    };
  },
  mounted() {
    this.getClientList();
    this.remoteTag();
  },
  beforeDestroy() {
    // 若进入的页面不是设备数据show页面，则将store中保存的查询信息清空
    if (!this.isMessage) {
      this.$store.commit('APPLICATION_SET_MSG_CLIENT_QUERY', { q: '', group_id: null, tags: '', online: 'all' });
      this.$store.commit('APPLICATION_SET_MSG_CLIENT_PAGE', { currentPage: 1 });
    }
  },
  computed: {
    ...mapState({
      groups: state => state.application.groups,
      currentPage: state => state.application.messageClientCurrentPage,
    }),
  },
  methods: {
    // 获取设备列表
    getClientList() {
      this.$http.get(`application/${this.applicationId}/client`,
        { params: {
          show_online_status: true,
          show_message_amount: true,
          ...this.$store.state.application.messageClientQueryForm,
          page: this.currentPage,
        } })
      .then((response) => {
        this.clientList = response.data.data;
        this.totalItem = response.data.total;
      }, (response) => {
        this.$iot.resp(response);
      });
    },
    // 渲染设备列表时获取分组名
    findGroup(id) {
      return _find(this.groups, { id }).name;
    },
    // 提交搜索
    onSubmitQuery() {
      // changePage会监测页码的变化，自动调用getClientList
      this.$store.commit('APPLICATION_SET_MSG_CLIENT_QUERY', { ...this.queryForm });
      if (this.currentPage !== 1) {
        this.$store.commit('APPLICATION_SET_MSG_CLIENT_PAGE', { currentPage: 1 });
      } else {
        this.getClientList();
      }
    },
    // 翻页
    changePage(page) {
      this.$store.commit('APPLICATION_SET_MSG_CLIENT_PAGE', { currentPage: page });
      this.getClientList();
    },
    // 搜索所有标签并存储
    remoteTag() {
      this.$http.get(`application/${this.applicationId}/tags`).then((response) => {
        this.tags = response.data.map(tag => ({ value: tag }));
      }, (response) => {
        this.$iot.resp(response);
      });
    },
    // 设备标签异步搜索
    querySearchAsync(queryString, cb) {
      let results = [];
      if (queryString) {
        results = this.tags.filter(tag => tag.value.indexOf(queryString.trim().toLowerCase()) === 0);
      } else {
        results = this.tags;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },
    // 点击
    showClient(row) {
      this.isMessage = true;
      this.$router.push(`message/${row.id}`);
    },
  },
};
</script>
